import type { HocuspocusProvider } from '@hocuspocus/provider';
import { createContext, use, type ReactNode } from 'react';
import { flushArtifactCollaboration } from '@/lib/api';

interface CollaborationContextValue {
  provider: HocuspocusProvider | null;
  artifactId: string | null;
}

const collaborationContext = createContext<CollaborationContextValue>({
  provider: null,
  artifactId: null,
});

export function CollaborationProvider({
  provider,
  artifactId,
  children,
}: {
  provider: HocuspocusProvider | null;
  artifactId: string | null;
  children: ReactNode;
}): React.ReactElement {
  return (
    <collaborationContext.Provider value={{ provider, artifactId }}>
      {children}
    </collaborationContext.Provider>
  );
}

export function useFlushBeforeSnapshot(): () => Promise<void> {
  const { artifactId } = use(collaborationContext);
  return async (): Promise<void> => {
    if (artifactId === null) return;
    await flushArtifactCollaboration(artifactId);
  };
}
